/**
 * SimplePaper Instagram Overlay Tracking - PostHog Integration
 * Tracking events for Instagram overlay experiment
 */

window.SP = window.SP || {};
window.SP.InstagramTracking = {
  
  // Track overlay becoming visible to user
  trackOverlayView: function(postId, placement, device) {
    if (typeof posthog !== 'undefined') {
      posthog.capture('overlay_view', {
        post_id: postId,
        placement: placement,
        device: device,
        viewport: window.innerWidth + 'x' + window.innerHeight,
        $set: {
          experiment_instagram_overlay: window.SP.experiments ? window.SP.experiments.instagram_overlay : 'control'
        }
      });
    }
    
    // Debug logging
    if (window.SP.FeatureFlags && window.SP.FeatureFlags.getFlag('debug_mode')) {
      console.log('SP Track: overlay_view', { postId, placement, device });
    }
  },

  // Track time spent hovering (desktop only)
  trackOverlayHover: function(postId, dwellMs) {
    if (typeof posthog !== 'undefined') {
      posthog.capture('overlay_hover_ms', {
        post_id: postId,
        dwell_ms: dwellMs,
        device: 'desktop',
        $set: {
          experiment_instagram_overlay: window.SP.experiments ? window.SP.experiments.instagram_overlay : 'control'
        }
      });
    }
    
    if (window.SP.FeatureFlags && window.SP.FeatureFlags.getFlag('debug_mode')) {
      console.log('SP Track: overlay_hover_ms', { postId, dwellMs });
    }
  },

  // Track CTA button clicks
  trackCtaClick: function(postId, ctaType, position) {
    if (typeof posthog !== 'undefined') {
      posthog.capture('overlay_cta_click', {
        post_id: postId,
        cta: ctaType,
        position: position,
        $set: {
          experiment_instagram_overlay: window.SP.experiments ? window.SP.experiments.instagram_overlay : 'control'
        }
      });
    }
    
    if (window.SP.FeatureFlags && window.SP.FeatureFlags.getFlag('debug_mode')) {
      console.log('SP Track: overlay_cta_click', { postId, ctaType, position });
    }
  },

  // Track overlay dismissal
  trackOverlayClose: function(postId, method) {
    if (typeof posthog !== 'undefined') {
      posthog.capture('overlay_close', {
        post_id: postId,
        method: method,
        $set: {
          experiment_instagram_overlay: window.SP.experiments ? window.SP.experiments.instagram_overlay : 'control'
        }
      });
    }
    
    if (window.SP.FeatureFlags && window.SP.FeatureFlags.getFlag('debug_mode')) {
      console.log('SP Track: overlay_close', { postId, method });
    }
  },

  // Track successful Instagram visits (primary metric)
  trackInstagramVisit: function(postId, position, variant) {
    if (typeof posthog !== 'undefined') {
      posthog.capture('outbound_instagram_visit', {
        post_id: postId,
        utm_campaign: 'journal_grid',
        position: position,
        device: this.getDevice(),
        variant: variant,
        $set: {
          experiment_instagram_overlay: variant
        }
      });
    }
    
    if (window.SP.FeatureFlags && window.SP.FeatureFlags.getFlag('debug_mode')) {
      console.log('SP Track: outbound_instagram_visit', { postId, position, variant });
    }
  },

  // Utility: Get device type
  getDevice: function() {
    return window.innerWidth <= 768 ? 'mobile' : 'desktop';
  },

  // Utility: Generate post ID from image element
  generatePostId: function(imageElement) {
    // Extract from src or use fallback
    const src = imageElement.src || '';
    const match = src.match(/\/([^\/]+)\.(jpg|png|webp)/i);
    return match ? match[1] : 'unknown_' + Date.now();
  },

  // Track baseline metrics for control group
  trackControlView: function(imageElement, position) {
    const postId = this.generatePostId(imageElement);
    
    if (typeof posthog !== 'undefined') {
      posthog.capture('control_image_view', {
        post_id: postId,
        position: position,
        device: this.getDevice(),
        $set: {
          experiment_instagram_overlay: 'control'
        }
      });
    }
    
    if (window.SP.FeatureFlags && window.SP.FeatureFlags.getFlag('debug_mode')) {
      console.log('SP Track: control_image_view', { postId, position });
    }
  }
};

// Initialize tracking for control group (baseline metrics)
function initControlTracking() {
  // Only track if NOT in overlay variant
  if (!window.SP.experiments || window.SP.experiments.instagram_overlay === 'control') {
    const imageContainers = document.querySelectorAll('.text-column__image');
    
    // Use IntersectionObserver to track when images are viewed
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting && !entry.target.dataset.controlTracked) {
          const img = entry.target.querySelector('img');
          if (img) {
            window.SP.InstagramTracking.trackControlView(img, index + 1);
            entry.target.dataset.controlTracked = 'true';
          }
        }
      });
    }, { threshold: 0.5 });

    imageContainers.forEach(container => {
      observer.observe(container);
    });
  }
}

// Initialize control tracking when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initControlTracking);
} else {
  // Wait a bit for SP.experiments to be set by feature flags
  setTimeout(initControlTracking, 100);
}